import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import DynamicTitle from "./DynamicTitle";
import LoopsForm from "./LoopsForm";
import WaveDivider from "./WaveDivider";

function About() {

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <DynamicTitle>About</DynamicTitle>

      <main className="flex-grow">
        {/* Introduction Section */}
        <section className="bg-background py-12">
          <div className="max-w-screen-md mx-auto px-4 text-center">
            <h1 className="text-3xl font-bold mb-4 text-text">Our Story</h1>
            <p className="text-lg mb-8 text-textSecondary">
              <em>
                RealignMind: Making Mental Wellness Tools Accessible to All
              </em>
            </p>
            <p className="text-base text-textSecondary">
              At RealignMind, we're dedicated to making mental wellness tools
              accessible to everyone. Our mission is rooted in personal
              experience and a desire to help others on their wellness journey.
            </p>
          </div>
        </section>

        <WaveDivider topColor="background" bottomColor="surfaceTint" />

        {/* Personal Story Section */}
        <section className="pt-8 pb-12 bg-surfaceTint">
          <div className="max-w-screen-md mx-auto px-4">
            <h2 className="text-2xl font-bold mb-4 text-center text-text">
              A Personal Journey of Discovery
            </h2>
            <p className="text-base mb-4 text-textSecondary">
              For most of my life, I've been exploring different approaches to mental wellness,
              working on aspects of myself that felt challenging. Despite various efforts,
              some patterns felt persistent—as if they'd always be part of my experience.
            </p>
            <p className="text-base mb-4 text-textSecondary">
              That changed when I tried bilateral stimulation techniques. During the session,
              I wasn't sure if it was working. I thought, "This might not be for me." But then,
              something shifted. I experienced a new perspective that allowed me to process
              difficult experiences differently.
            </p>
            <p className="text-base text-textSecondary">
              This moment was meaningful. I knew I wanted to help others access similar tools.
              I envisioned a way to make these research-backed techniques more accessible
              to those who might benefit from them.
            </p>
          </div>
        </section>

        <WaveDivider topColor="surfaceTint" bottomColor="background" />

        {/* The Birth of RealignMind Section */}
        <section className="pt-8 pb-12 bg-background">
          <div className="max-w-screen-md mx-auto px-4">
            <h2 className="text-2xl font-bold mb-4 text-center text-text">
              Creating RealignMind
            </h2>
            <p className="text-base mb-4 text-textSecondary">
              After years of study and dedication, RealignMind was created. Our
              platform is the result of my personal journey and
              professional efforts to bring research-backed mental wellness tools to more people. We
              offer self-directed sessions inspired by bilateral stimulation research,
              providing both scripted and unscripted options to support your
              mental wellness journey.
            </p>
            <p className="text-sm text-textSecondary italic">
              <strong>Note:</strong> Our sessions are not therapy and cannot replace professional
              mental health care. They are self-directed wellness tools inspired by research.
            </p>
          </div>
        </section>

        <WaveDivider topColor="background" bottomColor="surfaceTint" />

        {/* Our Commitment Section */}
        <section className="pt-8 pb-12 bg-surfaceTint">
          <div className="max-w-screen-md mx-auto px-4 text-center">
            <h2 className="text-2xl font-bold mb-4 text-text">Why We Do What We Do</h2>
            <p className="text-base mb-4 text-textSecondary">
              We believe that mental wellness tools should be accessible, supportive, and
              empowering. Our commitment is to provide you with research-backed tools and
              support for your mental wellness journey.
            </p>
          </div>
        </section>

        <WaveDivider topColor="surfaceTint" bottomColor="primary" />

        {/* Call to Action Section */}
        <section className="bg-primary pt-8 pb-12">
          <div className="max-w-screen-md mx-auto px-4 text-center">
            <LoopsForm />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
